import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useListStyles = makeStyles()(({ spacing }: Theme) => ({
  root: {
    padding: spacing(0, 1, 1, 1),
    '& > *': {
      marginBottom: spacing(2),
    },
  },
}));
